import {
  GetInteractionsRequest,
  SocialFeedPostsRequest,
  SocialFeedRequest,
  SocialFeedsRequest,
  FeedPostsPayload,
} from '@dap/sanity/types';

import {
  useGetSocialFeedPostsQuery,
  useGetSocialFeedsQuery,
  useGetSocialFeedQuery,
  useGetInteractionsQuery,
  useGetFeedPostsQuery,
} from './socialFeedApi';

export const useGetSocialFeeds = ({ brandKey }: SocialFeedsRequest) => {
  const state = useGetSocialFeedsQuery({ brandKey });

  if (state.isError) {
    return undefined;
  }

  if (state.status === 'pending') {
    return undefined;
  }

  return state.data;
};

export const useGetSocialFeed = ({ brandKey, slug }: SocialFeedRequest) => {
  const state = useGetSocialFeedQuery({ brandKey, slug });

  if (state.isError) {
    return undefined;
  }

  if (state.status === 'pending') {
    return undefined;
  }

  return state.data;
};

export const useGetSocialFeedPosts = ({
  brandKey,
  feeds,
  limit,
  offset,
}: SocialFeedPostsRequest) => {
  const state = useGetSocialFeedPostsQuery({ brandKey, feeds, limit, offset });

  if (state.isError) {
    return undefined;
  }

  if (state.status === 'pending') {
    return undefined;
  }

  return state.data;
};

export const useGetFeedPosts = ({
  feedId,
  limit,
  offset,
}: FeedPostsPayload) => {
  const state = useGetFeedPostsQuery({ feedId, limit, offset });

  if (state.isError) {
    return undefined;
  }

  if (state.status === 'pending') {
    return undefined;
  }

  return state.data;
};


export const useGetInteractions = (props: GetInteractionsRequest) => {
  const state = useGetInteractionsQuery(props);

  if (state.isError) {
    return undefined;
  }

  if (state.status === 'pending') {
    return undefined;
  }

  return state.data;
};
